import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "ai",
    iconColor: "white",
    text: "Gen AI engine assistance",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "eyeFocus",
    iconColor: "white",
    text: "App visibility and data",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithCloud",
    iconColor: "white",
    text: "Intent-based \norchestration into Edge",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "autonomousManagement",
    iconColor: "white",
    text: "Autonomous \nmanagement of \napplications based on \nintent",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_IEAM_2 = {
  title: "Empowering enterprises",
  titleNumber: "2.",
  text: `<span style="font-size: 36px; font-weight: 700;">Now with new Gen AI Engine assistance</span>\n\n<span style="opacity: 0.8; line-height: 41px;">Provides a platform for the enterprises to subscribe, deploy and\n manage applications with the assistance of AI.</span>`,
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Challenges Solved",
    onClick: () => setCurrentPage("ENG_104"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_102"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Introduction_03.png",
  demoButtons: [
    {
      label: "PROVIDER DEMO",
      onClick: () => {
        setPreviousPage("ENG_103");
        setCurrentPage("ENG_105");
      },
      endIcon: "play",
    },
    {
      label: "ENTERPRISE DEMO",
      onClick: () => {
        setPreviousPage("ENG_103");
        setCurrentPage("ENG_111");
      },
      endIcon: "play",
    },
    {
      label: "AI ASSISTED DEMO",
      onClick: () => {
        setPreviousPage("ENG_103");
        setCurrentPage("ENG_116");
      },
      endIcon: "play",
    },
  ],
};
